import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { formatINR } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Heart, ShoppingBag, X } from "lucide-react";

export default function Wishlist() {
  const { wishlist, toggleWishlist, addToCart } = useCart();
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="max-w-md mx-auto px-4 py-24 text-center">
        <Heart className="h-16 w-16 mx-auto text-[#78716C] mb-6" />
        <h1 className="font-serif text-3xl mb-4">Sign in to view wishlist</h1>
        <Link
          to="/login"
          className="inline-block bg-[#7C1F30] hover:bg-[#8D2A3D] text-white px-8 py-4 rounded-full uppercase text-xs tracking-[0.2em]"
        >
          Sign In
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12 md:py-16">
      <h1 className="font-serif text-4xl sm:text-5xl text-[#1C1917] mb-10">Your Wishlist</h1>

      {wishlist.length === 0 ? (
        <div className="py-24 text-center">
          <Heart className="h-16 w-16 mx-auto text-[#78716C] mb-6" />
          <p className="text-[#78716C] mb-6">No favourites yet.</p>
          <Link
            to="/shop"
            className="inline-block bg-[#7C1F30] hover:bg-[#8D2A3D] text-white px-8 py-4 rounded-full uppercase text-xs tracking-[0.2em]"
          >
            Explore Products
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {wishlist.map((p) => (
            <div
              key={p.id}
              data-testid={`wishlist-item-${p.id}`}
              className="flex gap-4 p-4 bg-white border border-[#E7E5E4] rounded-lg"
            >
              <Link to={`/product/${p.slug || p.id}`}>
                <img src={p.image} alt={p.name} className="w-28 h-36 object-cover rounded-md" />
              </Link>
              <div className="flex-1 flex flex-col">
                <div className="flex-1">
                  <Link to={`/product/${p.slug || p.id}`}>
                    <h3 className="font-serif text-lg mb-1 hover:text-[#7C1F30]">{p.name}</h3>
                  </Link>
                  <p className="text-xs text-[#78716C] mb-2 capitalize">
                    {p.category.replace("-", " ")}
                  </p>
                  <div className="font-medium">{formatINR(p.price)}</div>
                </div>
                <div className="flex gap-2 mt-3">
                  <button
                    onClick={() => addToCart(p.id, 1)}
                    data-testid={`wishlist-add-cart-${p.id}`}
                    className="flex-1 flex items-center justify-center gap-2 py-2 bg-[#1C1917] text-white text-xs uppercase tracking-[0.2em] rounded-full hover:bg-[#3F3F3E]"
                  >
                    <ShoppingBag className="h-3.5 w-3.5" /> Add
                  </button>
                  <button
                    onClick={() => toggleWishlist(p.id)}
                    data-testid={`wishlist-remove-${p.id}`}
                    className="p-2 border border-[#E7E5E4] rounded-full hover:bg-[#F5F5F4]"
                  >
                    <X className="h-4 w-4" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
